import { render, staticRenderFns } from "./addsound.vue?vue&type=template&id=69867b48&scoped=true"
import script from "./addsound.vue?vue&type=script&lang=js"
export * from "./addsound.vue?vue&type=script&lang=js"
import style0 from "./addsound.vue?vue&type=style&index=0&id=69867b48&prod&scoped=true&lang=css"
import style1 from "./addsound.vue?vue&type=style&index=1&id=69867b48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69867b48",
  null
  
)

export default component.exports